import { Tooltip } from "@mui/material";
import HeartIcon from "@mui/icons-material/Favorite";
import useHeartFailure from "components/pages/transmissions/modal/patient/tabs/generalInformation/profile/heartFailure/useHeartFailure";

const HeartFailure = () => {
  const { profile, handleClick } = useHeartFailure();

  return (
    <Tooltip title="Centra Heart Failure">
      <HeartIcon
        disabled
        onClick={(e) => handleClick(e)}
        style={{
          color: !profile?.sub_account ? "grey" : "orange",
          height: 28,
          width: 30,
          marginTop: "10px",
          cursor: "pointer",
        }}
      />
    </Tooltip>
  );
};

export default HeartFailure;
